<app-loader [enable]="loading$ | async">
  <mat-icon>visibility</mat-icon>
  <span>{{ 'real_conversions.walled_garden' | translate }}</span>
  <mat-slide-toggle color="primary"
                    [disabled]="loading$ | async"
                    [checked]="(_profile$ | async).attributes.real_conversions_correction_mode !== 0"
                    (toggleChange)="toggleRealConversions()"></mat-slide-toggle>
</app-loader>
